import { render, staticRenderFns } from "./ProgramManager.vue?vue&type=template&id=54a5d6dd&scoped=true"
import script from "./ProgramManager.vue?vue&type=script&lang=js"
export * from "./ProgramManager.vue?vue&type=script&lang=js"
import style0 from "./ProgramManager.vue?vue&type=style&index=0&id=54a5d6dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5d6dd",
  null
  
)

export default component.exports